const finishedPages = ["pl", "en", "nn", "cs", "fr", "sv", "fi", "ru"];

export const certifiedPageFinishedForLocale = (
  locale: string,
  isCertified: boolean
) => {
  if (locale === "sv" && !isCertified) {
    return false;
  }
  return finishedPages.includes(locale);
};
